webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(40);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueTransferDom = __webpack_require__(159);
	
	var _vueTransferDom2 = _interopRequireDefault(_vueTransferDom);
	
	var _Root = __webpack_require__(144);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _main = __webpack_require__(46);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _router = __webpack_require__(43);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _registerComponents = __webpack_require__(42);
	
	var _registerComponents2 = _interopRequireDefault(_registerComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(99);
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueTransferDom2.default);
	_vue2.default.use(_main2.default);
	
	(0, _registerComponents2.default)(_vue2.default);
	
	_router2.default.start(_Root2.default, '#root');

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.eventBus = undefined;
	
	var _events = __webpack_require__(98);
	
	var _objectAssign = __webpack_require__(126);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventBus = exports.eventBus = (0, _objectAssign2.default)({}, _events.EventEmitter.prototype);

/***/ },
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs sh\">$ npm install wovue-off-canvas --save\n</code></pre>";

/***/ },
/* 40 */,
/* 41 */,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerComponents;
	
	var _AppFooter = __webpack_require__(155);
	
	var _AppFooter2 = _interopRequireDefault(_AppFooter);
	
	var _AppTable = __webpack_require__(156);
	
	var _AppTable2 = _interopRequireDefault(_AppTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerComponents(Vue) {
	  Vue.component('app-footer', _AppFooter2.default);
	  Vue.component('app-table', _AppTable2.default);
	}

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(40);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  hashbang: true,
	  history: false,
	  linkActiveClass: 'is-active',
	  transitionOnLoad: true
	});
	
	router.map(_routes.routes);
	
	router.beforeEach(function () {
	  window.scrollTo(0, 0);
	});
	
	exports.default = router;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routes = undefined;
	
	var _HomePage = __webpack_require__(153);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	var _HomeDefaultPage = __webpack_require__(152);
	
	var _HomeDefaultPage2 = _interopRequireDefault(_HomeDefaultPage);
	
	var _HomeUsagePage = __webpack_require__(154);
	
	var _HomeUsagePage2 = _interopRequireDefault(_HomeUsagePage);
	
	var _HomeApiPage = __webpack_require__(151);
	
	var _HomeApiPage2 = _interopRequireDefault(_HomeApiPage);
	
	var _ExamplesPage = __webpack_require__(149);
	
	var _ExamplesPage2 = _interopRequireDefault(_ExamplesPage);
	
	var _ExamplesDefaultPage = __webpack_require__(148);
	
	var _ExamplesDefaultPage2 = _interopRequireDefault(_ExamplesDefaultPage);
	
	var _ExamplesRealWorldPage = __webpack_require__(150);
	
	var _ExamplesRealWorldPage2 = _interopRequireDefault(_ExamplesRealWorldPage);
	
	var _DocsExamplePage = __webpack_require__(146);
	
	var _DocsExamplePage2 = _interopRequireDefault(_DocsExamplePage);
	
	var _DocsMarkdownExamplePage = __webpack_require__(147);
	
	var _DocsMarkdownExamplePage2 = _interopRequireDefault(_DocsMarkdownExamplePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = exports.routes = {
	  '/': {
	    name: 'Home',
	    component: _HomePage2.default,
	    subRoutes: {
	      '/': {
	        name: 'HomeDefaultPage',
	        component: _HomeDefaultPage2.default
	      },
	      '/usage': {
	        name: 'HomeUsagePage',
	        component: _HomeUsagePage2.default
	      },
	      '/api': {
	        name: 'HomeApiPage',
	        component: _HomeApiPage2.default
	      }
	    }
	  },
	  '/examples': {
	    name: 'Examples',
	    component: _ExamplesPage2.default,
	    subRoutes: {
	      '/': {
	        name: 'ExamplesDefaultPage',
	        component: _ExamplesDefaultPage2.default
	      },
	      '/real-world': {
	        name: 'ExamplesRealWorldPage',
	        component: _ExamplesRealWorldPage2.default
	      }
	    }
	  },
	  '/docs-example': {
	    name: 'DocsExample',
	    component: _DocsExamplePage2.default
	  },
	  '/docs-markdown-example': {
	    name: 'DocsMarkdownExample',
	    component: _DocsMarkdownExamplePage2.default
	  }
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.openOffCanvas = exports.closeOffCanvas = exports.toggleOffCanvas = exports.directive = undefined;
	
	var _typeof2 = __webpack_require__(66);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var directive = {
	  bind: function bind() {
	    if (!this.expression) {
	      console.error('[off-canvas]: Expected a Value, got \'' + this.expression + '\'. (found in ' + this.vm.constructor.name + ')');
	    }
	    if (typeof this.expression !== 'string') {
	      console.error('[off-canvas]: Expected String, got ' + (0, _typeof3.default)(this.expression) + '. (found in ' + this.vm.constructor.name + ')');
	    }
	
	    this.$wv = {};
	
	    this.$wv.onToggle = onToggle.bind(this);
	    _helpers.eventBus.on('toggle:directive', this.$wv.onToggle);
	
	    this.el.setAttribute('aria-expanded', false);
	    this.el.setAttribute('aria-controls', this.expression);
	
	    if (this.arg === 'toggle') {
	      this.$wv.toggleOffCanvas = toggleOffCanvas.bind(undefined, this.expression);
	      this.el.addEventListener('click', this.$wv.toggleOffCanvas);
	    }
	
	    if (this.arg === 'close') {
	      this.$wv.closeOffCanvas = closeOffCanvas.bind(undefined, this.expression);
	      this.el.addEventListener('click', this.$wv.closeOffCanvas);
	    }
	
	    if (this.arg === 'open') {
	      this.$wv.openOffCanvas = openOffCanvas.bind(undefined, this.expression);
	      this.el.addEventListener('click', this.$wv.openOffCanvas);
	    }
	  },
	  unbind: function unbind() {
	    _helpers.eventBus.removeListener('toggle:directive', this.$wv.onToggle);
	
	    if (this.arg === 'toggle') {
	      this.el.removeEventListener('click', this.$wv.toggleOffCanvas);
	    }
	
	    if (this.arg === 'close') {
	      this.el.removeEventListener('click', this.$wv.closeOffCanvas);
	    }
	
	    if (this.arg === 'open') {
	      this.el.removeEventListener('click', this.$wv.openOffCanvas);
	    }
	  }
	};
	
	function toggleOffCanvas(offCanvasRef) {
	  _helpers.eventBus.emit('toggle:off-canvas', offCanvasRef, 'toggle');
	}
	
	function closeOffCanvas(offCanvasRef) {
	  _helpers.eventBus.emit('toggle:off-canvas', offCanvasRef, 'close');
	}
	
	function openOffCanvas(offCanvasRef) {
	  _helpers.eventBus.emit('toggle:off-canvas', offCanvasRef, 'open');
	}
	
	function onToggle(offCanvas) {
	  if (this.expression === offCanvas.ref) {
	    this.el.setAttribute('aria-expanded', offCanvas.opened);
	  }
	}
	
	exports.directive = directive;
	exports.toggleOffCanvas = toggleOffCanvas;
	exports.closeOffCanvas = closeOffCanvas;
	exports.openOffCanvas = openOffCanvas;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.directive = exports.openOffCanvas = exports.closeOffCanvas = exports.toggleOffCanvas = exports.components = undefined;
	
	var _OffCanvas = __webpack_require__(157);
	
	var _OffCanvas2 = _interopRequireDefault(_OffCanvas);
	
	var _OffCanvasWrap = __webpack_require__(158);
	
	var _OffCanvasWrap2 = _interopRequireDefault(_OffCanvasWrap);
	
	var _directive = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(100);
	
	var components = {
	  OffCanvas: _OffCanvas2.default,
	  OffCanvasWrap: _OffCanvasWrap2.default
	};
	var Vue = {};
	
	var offCanvasPlugin = {
	  install: function install(_Vue) {
	    Vue = _Vue;
	
	    if (!Vue.prototype.$wv) {
	      Vue.prototype.$wv = {};
	    }
	    Vue.prototype.$wv.offCanvas = {
	      toggle: _directive.toggleOffCanvas,
	      close: _directive.closeOffCanvas,
	      open: _directive.openOffCanvas
	    };
	
	    Vue.component('wv-off-canvas', _OffCanvas2.default);
	    Vue.component('wv-off-canvas-wrap', _OffCanvasWrap2.default);
	    Vue.directive('off-canvas', _directive.directive);
	  }
	};
	
	if (typeof window !== 'undefined' && window.Vue) {
	  window.Vue.component('wv-off-canvas', _OffCanvas2.default);
	  window.Vue.component('wv-off-canvas-wrap', _OffCanvasWrap2.default);
	  window.Vue.directive('off-canvas', _directive.directive);
	}
	exports.default = offCanvasPlugin;
	exports.components = components;
	exports.toggleOffCanvas = _directive.toggleOffCanvas;
	exports.closeOffCanvas = _directive.closeOffCanvas;
	exports.openOffCanvas = _directive.openOffCanvas;
	exports.directive = _directive.directive;

/***/ },
/* 47 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: [{
	    name: 'repoUser',
	    type: String,
	    required: true
	  }, {
	    name: 'repoName',
	    type: String,
	    required: true
	  }, {
	    name: 'background',
	    type: String,
	    default: function _default() {
	      return '#151513';
	    }
	  }, {
	    name: 'color',
	    type: String,
	    default: function _default() {
	      return '#ffffff';
	    }
	  }],
	  computed: {
	    ghLink: function ghLink() {
	      return 'https://github.com/' + this.repoUser + '/' + this.repoName;
	    }
	  }
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GhCorner = __webpack_require__(143);
	
	var _GhCorner2 = _interopRequireDefault(_GhCorner);
	
	var _Sidebar = __webpack_require__(145);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Root',
	  components: {
	    GhCorner: _GhCorner2.default,
	    Sidebar: _Sidebar2.default
	  }
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _installation = __webpack_require__(39);
	
	var _installation2 = _interopRequireDefault(_installation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocsExamplePage',
	  data: function data() {
	    return {
	      snippet: _installation2.default,
	      table: [{
	        name: 'David',
	        gender: 'Male',
	        code: '`0132`',
	        status: false
	      }, {
	        name: 'Other',
	        gender: 'Male',
	        code: '`123`',
	        status: ''
	      }]
	    };
	  }
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docsMarkdownExample = __webpack_require__(111);
	
	var _docsMarkdownExample2 = _interopRequireDefault(_docsMarkdownExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocsMarkdownExamplePage',
	  data: function data() {
	    return {
	      docsMarkdownExample: _docsMarkdownExample2.default
	    };
	  }
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultExample = __webpack_require__(110);
	
	var _defaultExample2 = _interopRequireDefault(_defaultExample);
	
	var _exampleV = __webpack_require__(113);
	
	var _exampleV2 = _interopRequireDefault(_exampleV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ExamplesDefaultPage',
	  data: function data() {
	    return {
	      snippets: {
	        defaultExample: _defaultExample2.default,
	        v01: _exampleV2.default
	      }
	    };
	  }
	};

/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Examples'
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _exampleRw = __webpack_require__(112);
	
	var _exampleRw2 = _interopRequireDefault(_exampleRw);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ExamplesRealWorldPage',
	  data: function data() {
	    return {
	      snippets: {
	        rw01: _exampleRw2.default
	      }
	    };
	  },
	
	  methods: {
	    onClose: function onClose() {
	      console.log('OffCanvas closed');
	    },
	    onOpen: function onOpen() {
	      console.log('OffCanvas opened');
	    }
	  }
	};

/***/ },
/* 55 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'HomePage',
	  data: function data() {
	    return {
	      tables: {
	        offCanvasWrap: {
	          props: [{
	            name: 'ref',
	            type: 'String',
	            required: 'true',
	            default: null,
	            description: 'OffCanvasWrap identifier.'
	          }]
	        },
	        offCanvas: {
	          directive: [{
	            expression: 'OffCanvas identifier. (the `ref` prop from the Dialog)',
	            expects: 'String',
	            argument: 'toggle|open|close',
	            description: 'Toggle|Open|Close the OffCanvas on click.',
	            example: '`<a v-off-canvas:toggle="menu">Link</a>`'
	          }],
	          props: [{
	            name: 'ref',
	            type: '`String`',
	            required: 'true',
	            default: null,
	            description: 'OffCanvas identifier.'
	          }, {
	            name: 'class',
	            type: '`String`',
	            required: 'false',
	            default: '`false`',
	            description: 'OffCanvas `class` attribute.'
	          }, {
	            name: 'align',
	            type: '`String`',
	            required: 'false',
	            default: '`"left"`',
	            description: 'OffCanvas align. It can be `"left"` or `"right"`.'
	          }, {
	            name: 'width',
	            type: '`Number`',
	            required: 'false',
	            default: '`false`',
	            description: 'OffCanvas `max-width` style rule. (e.g. `300`, `70%`)'
	          }, {
	            name: 'wrapRef',
	            type: '`String`',
	            required: 'false',
	            default: '`false`',
	            description: 'OffCanvasWrap to push on open OffCanvas.'
	          }, {
	            name: 'overlayBackground',
	            type: '`String`',
	            required: 'false',
	            default: '`"rgba(0, 0, 0, .5)"`',
	            description: 'Overlay background color.'
	          }, {
	            name: 'closeOnEsc',
	            type: '`Boolean`',
	            required: 'false',
	            default: '`true`',
	            description: 'This determines if pressing the `esc` key will close the OffCanvas.'
	          }, {
	            name: 'closeOnOutsideClick',
	            type: '`Boolean`',
	            required: 'false',
	            default: '`true`',
	            description: 'This determines if clicking on the overlay will close the OffCanvas.'
	          }, {
	            name: 'role `new`',
	            type: '`String`',
	            required: 'false',
	            default: '`false`',
	            description: 'OffCanvas `role` attribute.'
	          }, {
	            name: 'ariaLabelledby `new`',
	            type: '`String`',
	            required: 'false',
	            default: '`false`',
	            description: 'OffCanvas `aria-labelledby` attribute.'
	          }],
	          events: [{
	            name: 'opened',
	            type: 'emitted',
	            description: 'Fired when the OffCanvas is opened. The animation starts.'
	          }, {
	            name: 'closed',
	            type: 'emitted',
	            description: 'Fired when the OffCanvas is closed. The animation ends.'
	          }]
	        }
	      }
	    };
	  }
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _installation = __webpack_require__(39);
	
	var _installation2 = _interopRequireDefault(_installation);
	
	var _installationInclude = __webpack_require__(117);
	
	var _installationInclude2 = _interopRequireDefault(_installationInclude);
	
	var _installationCommonjs = __webpack_require__(116);
	
	var _installationCommonjs2 = _interopRequireDefault(_installationCommonjs);
	
	var _installationCommonjsAlternative = __webpack_require__(114);
	
	var _installationCommonjsAlternative2 = _interopRequireDefault(_installationCommonjsAlternative);
	
	var _installationCommonjsAlternative3 = __webpack_require__(115);
	
	var _installationCommonjsAlternative4 = _interopRequireDefault(_installationCommonjsAlternative3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'HomeDefaultPage',
	  data: function data() {
	    return {
	      snippets: {
	        installationInclude: _installationInclude2.default,
	        installation: _installation2.default,
	        installationCommonjs: _installationCommonjs2.default,
	        installationCommonjsAlternative: _installationCommonjsAlternative2.default,
	        installationCommonjsAlternative2: _installationCommonjsAlternative4.default
	      }
	    };
	  }
	};

/***/ },
/* 57 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'HomePage'
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _usage = __webpack_require__(118);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _usage3 = __webpack_require__(119);
	
	var _usage4 = _interopRequireDefault(_usage3);
	
	var _usage5 = __webpack_require__(120);
	
	var _usage6 = _interopRequireDefault(_usage5);
	
	var _usageGuide = __webpack_require__(121);
	
	var _usageGuide2 = _interopRequireDefault(_usageGuide);
	
	var _usageGuide3 = __webpack_require__(122);
	
	var _usageGuide4 = _interopRequireDefault(_usageGuide3);
	
	var _usageGuide5 = __webpack_require__(123);
	
	var _usageGuide6 = _interopRequireDefault(_usageGuide5);
	
	var _usageGuide7 = __webpack_require__(124);
	
	var _usageGuide8 = _interopRequireDefault(_usageGuide7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'HomeUsagePage',
	  data: function data() {
	    return {
	      snippets: {
	        usage01: _usage2.default,
	        usage02: _usage4.default,
	        usage021: _usage6.default,
	        usageGuide01: _usageGuide2.default,
	        usageGuide02: _usageGuide4.default,
	        usageGuide03: _usageGuide6.default,
	        usageGuide04: _usageGuide8.default
	      }
	    };
	  }
	};

/***/ },
/* 59 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(63);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _marked2 = __webpack_require__(125);
	
	var _marked3 = _interopRequireDefault(_marked2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      empty: '—<span class="o-screen-reader">none</span>'
	    };
	  },
	
	  props: [{
	    name: 'data',
	    type: Array,
	    required: true
	  }],
	  computed: {
	    columns: function columns() {
	      if (!this.data.length) {
	        return [];
	      }
	
	      return (0, _keys2.default)(this.data[0]);
	    }
	  },
	  methods: {
	    marked: function marked(markdown) {
	      return (0, _marked3.default)(markdown);
	    }
	  }
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(15);
	
	exports.default = {
	  props: [{
	    name: 'overlayBackground',
	    type: String,
	    default: 'rgba(0, 0, 0, .5)'
	  }, {
	    name: 'class',
	    type: String,
	    default: false
	  }, {
	    name: 'align',
	    type: String,
	    default: 'left'
	  }, {
	    name: 'width',
	    type: [Number, String],
	    default: false
	  }, {
	    name: 'ref',
	    type: String,
	    required: true
	  }, {
	    name: 'closeOnEsc',
	    type: Boolean,
	    default: true
	  }, {
	    name: 'closeOnOutsideClick',
	    type: Boolean,
	    default: true
	  }, {
	    name: 'wrapRef',
	    type: String,
	    default: false
	  }, {
	    name: 'role',
	    type: String,
	    default: false
	  }, {
	    name: 'ariaLabelledby',
	    type: String,
	    default: false
	  }],
	  data: function data() {
	    return {
	      isOpen: false,
	      ariaHidden: true
	    };
	  },
	
	  computed: {
	    transitionClass: function transitionClass() {
	      return 'wv-off-canvas-' + this.align;
	    },
	    offCanvasMaxWidth: function offCanvasMaxWidth() {
	      if (!this.width) {
	        return false;
	      }
	
	      if (typeof this.width === 'number') {
	        return this.width + 'px';
	      }
	
	      if (typeof this.width === 'string') {
	        return this.width;
	      }
	    }
	  },
	  ready: function ready() {
	    _helpers.eventBus.on('toggle:off-canvas', this.onToggle);
	    document.addEventListener('keydown', this.onKeyDown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _helpers.eventBus.removeListener('toggle:off-canvas', this.onToggle);
	    document.removeEventListener('keydown', this.onKeyDown);
	  },
	
	  methods: {
	    onKeyDown: function onKeyDown(event) {
	      if (this.isOpen && event.which === 27 && this.closeOnEsc) {
	        event.stopPropagation();
	        this.close();
	      }
	    },
	    onToggle: function onToggle(offCanvasRef, actionType) {
	      if (this.ref !== offCanvasRef) return;
	
	      switch (actionType) {
	        case 'toggle':
	          {
	            if (this.isOpen) {
	              this.close();
	            } else {
	              this.open();
	            }
	            break;
	          }
	        case 'close':
	          {
	            this.close();
	            break;
	          }
	        case 'open':
	          {
	            this.open();
	            break;
	          }
	        default:
	          {}
	      }
	    },
	    close: function close(event) {
	      if (event) {
	        if (!this.closeOnOutsideClick) {
	          return;
	        }
	      }
	
	      _helpers.eventBus.emit('toggle:off-canvas-wrap', {
	        wrapRef: this.wrapRef,
	        toOpen: false
	      });
	
	      this.isOpen = false;
	    },
	    open: function open() {
	      var _this = this;
	
	      _helpers.eventBus.emit('toggle:directive', {
	        ref: this.ref,
	        opened: true
	      });
	
	      this.isOpen = true;
	      this.ariaHidden = false;
	      this.$emit('opened');
	
	
	      this.$nextTick(function () {
	        _this.openWrap();
	      });
	    },
	    openWrap: function openWrap() {
	
	      var offCanvasWidth = this.offCanvasMaxWidth || this.$els.offCanvas.getBoundingClientRect().width + 'px';
	
	      _helpers.eventBus.emit('toggle:off-canvas-wrap', {
	        wrapRef: this.wrapRef,
	        offCanvasData: {
	          offCanvasWidth: offCanvasWidth,
	          offCanvasAlign: this.align
	        },
	        toOpen: true
	      });
	    },
	    onAnimationEnd: function onAnimationEnd() {
	      if (!this.isOpen) {
	        _helpers.eventBus.emit('toggle:directive', {
	          ref: this.ref,
	          opened: false
	        });
	
	        this.ariaHidden = true;
	        this.$emit('closed');
	      }
	    }
	  }
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(15);
	
	exports.default = {
	  props: [{
	    name: 'ref',
	    type: String,
	    required: true
	  }],
	  data: function data() {
	    return {
	      isOpen: false,
	
	      offCanvasWidth: 0,
	      offCanvasAlign: ''
	    };
	  },
	
	  computed: {
	    contentTransform: function contentTransform() {
	      if (this.isOpen) {
	        if (this.offCanvasAlign === 'right') {
	          return 'translate3d(-' + this.offCanvasWidth + ', 0, 0)';
	        }
	        return 'translate3d(' + this.offCanvasWidth + ', 0, 0)';
	      }
	      return '';
	    }
	  },
	  ready: function ready() {
	    _helpers.eventBus.on('toggle:off-canvas-wrap', this.onToggle);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _helpers.eventBus.removeListener('toggle:off-canvas-wrap', this.onToggle);
	  },
	
	  methods: {
	    onToggle: function onToggle(_ref) {
	      var wrapRef = _ref.wrapRef;
	      var offCanvasData = _ref.offCanvasData;
	      var toOpen = _ref.toOpen;
	
	      if (this.ref === wrapRef) {
	        if (toOpen) {
	          this.open(offCanvasData);
	        } else {
	          this.close();
	        }
	      }
	    },
	    close: function close() {
	      this.isOpen = false;
	    },
	    open: function open(_ref2) {
	      var offCanvasWidth = _ref2.offCanvasWidth;
	      var offCanvasAlign = _ref2.offCanvasAlign;
	
	      this.offCanvasWidth = offCanvasWidth;
	      this.offCanvasAlign = offCanvasAlign;
	
	      this.isOpen = true;
	    }
	  }
	};

/***/ },
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 100 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 101 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 102 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 103 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 104 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 105 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 106 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 107 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 108 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 109 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 110 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>wv-off-canvas</span> <span class=hljs-attr>ref</span>=<span class=hljs-string>\"sidebar\"</span> <span class=hljs-attr>class</span>=<span class=hljs-string>\"my-sidebar\"</span>&gt;</span>\n  <span class=hljs-comment>&lt;!-- lorem content --&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"sidebar\"</span>&gt;</span>Close<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>wv-off-canvas</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"sidebar\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n</code></pre> <pre><code class=\"hljs scss\"><span class=hljs-selector-class>.my-sidebar</span> {\n  <span class=hljs-attribute>background-color</span>: <span class=hljs-number>#F1524B</span>;\n  <span class=hljs-attribute>padding</span>: <span class=hljs-number>2rem</span>;\n  <span class=hljs-attribute>color</span>: <span class=hljs-number>#ffffff</span>;\n}\n</code></pre>";

/***/ },
/* 111 */
/***/ function(module, exports) {

	module.exports = "<h1 id=create-pages-using-markdown>Create pages using markdown</h1> <p>Just create a new component in <code>pages</code> folder, and import your markdown file, it will be pre-processed by <a href=https://www.npmjs.com/package/markdown-loader>markdown loader</a> and <a href=https://github.com/webpack/html-loader>html loader</a>.</p> <pre><code class=\"hljs vue\">&lt;template&gt;\n  &lt;main class=\"c-main\"&gt;\n    &lt;div class=\"u-gutter\"&gt;\n      &lt;!-- insert plain HTML data --&gt;\n      &lt;article class=\"markdown-body c-markdown-body\" v-html=\"docsMarkdownExample\"&gt;&lt;/article&gt;\n    &lt;/div&gt;\n    &lt;app-footer&gt;&lt;/app-footer&gt;\n  &lt;/main&gt;\n&lt;/template&gt;\n\n&lt;script&gt;\n  // import markdown\n  import docsMarkdownExample from 'src-docs/app/snippets/docs-markdown-example.md'\n\n  export default {\n    name: 'DocsMarkdownExamplePage',\n    data () {\n      return {\n        docsMarkdownExample\n      }\n    }\n  }\n&lt;/script&gt;\n</code></pre> <p>That&#39;s it!</p> <h1 id=marked>marked</h1> <blockquote> <p>A full-featured markdown parser and compiler, written in JavaScript. Built for speed.</p> </blockquote> <p><a href=http://badge.fury.io/js/marked><img src=https://badge.fury.io/js/marked.png alt=\"NPM version\"></a></p> <h2 id=install>Install</h2> <pre><code class=\"hljs bash\">npm install marked --save\n</code></pre> <h2 id=usage>Usage</h2> <p>Minimal usage:</p> <pre><code class=\"hljs js\"><span class=hljs-keyword>var</span> marked = <span class=hljs-built_in>require</span>(<span class=hljs-string>'marked'</span>);\n<span class=hljs-built_in>console</span>.log(marked(<span class=hljs-string>'I am using __markdown__.'</span>));\n<span class=hljs-comment>// Outputs: &lt;p&gt;I am using &lt;strong&gt;markdown&lt;/strong&gt;.&lt;/p&gt;</span>\n</code></pre> <p>Example setting options with default values:</p> <pre><code class=\"hljs js\"><span class=hljs-keyword>var</span> marked = <span class=hljs-built_in>require</span>(<span class=hljs-string>'marked'</span>);\nmarked.setOptions({\n  renderer: <span class=hljs-keyword>new</span> marked.Renderer(),\n  gfm: <span class=hljs-literal>true</span>,\n  tables: <span class=hljs-literal>true</span>,\n  breaks: <span class=hljs-literal>false</span>,\n  pedantic: <span class=hljs-literal>false</span>,\n  sanitize: <span class=hljs-literal>false</span>,\n  smartLists: <span class=hljs-literal>true</span>,\n  smartypants: <span class=hljs-literal>false</span>\n});\n\n<span class=hljs-built_in>console</span>.log(marked(<span class=hljs-string>'I am using __markdown__.'</span>));\n</code></pre> <h3 id=browser>Browser</h3> <pre><code class=\"hljs html\"><span class=hljs-meta>&lt;!doctype html&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>html</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>head</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>meta</span> <span class=hljs-attr>charset</span>=<span class=hljs-string>\"utf-8\"</span>/&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>title</span>&gt;</span>Marked in the browser<span class=hljs-tag>&lt;/<span class=hljs-name>title</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>script</span> <span class=hljs-attr>src</span>=<span class=hljs-string>\"lib/marked.js\"</span>&gt;</span><span class=undefined></span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>head</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>body</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>div</span> <span class=hljs-attr>id</span>=<span class=hljs-string>\"content\"</span>&gt;</span><span class=hljs-tag>&lt;/<span class=hljs-name>div</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>script</span>&gt;</span><span class=javascript>\n    <span class=hljs-built_in>document</span>.getElementById(<span class=hljs-string>'content'</span>).innerHTML =\n      marked(<span class=hljs-string>'# Marked in browser\\n\\nRendered by **marked**.'</span>);\n  </span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>body</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>html</span>&gt;</span>\n</code></pre> <h2 id=marked-markdownstring-options-callback->marked(markdownString [,options] [,callback])</h2> <h3 id=markdownstring>markdownString</h3> <p>Type: <code>string</code></p> <p>String of markdown source to be compiled.</p> <h3 id=options>options</h3> <p>Type: <code>object</code></p> <p>Hash of options. Can also be set using the <code>marked.setOptions</code> method as seen above.</p> <h3 id=callback>callback</h3> <p>Type: <code>function</code></p> <p>Function called when the <code>markdownString</code> has been fully parsed when using async highlighting. If the <code>options</code> argument is omitted, this can be used as the second argument.</p> <h2 id=options>Options</h2> <h3 id=highlight>highlight</h3> <p>Type: <code>function</code></p> <p>A function to highlight code blocks. The first example below uses async highlighting with <a href=https://github.com/rvagg/node-pygmentize-bundled>node-pygmentize-bundled</a>, and the second is a synchronous example using <a href=https://github.com/isagalaev/highlight.js>highlight.js</a>:</p> <pre><code class=\"hljs js\"><span class=hljs-keyword>var</span> marked = <span class=hljs-built_in>require</span>(<span class=hljs-string>'marked'</span>);\n\n<span class=hljs-keyword>var</span> markdownString = <span class=hljs-string>'```js\\n console.log(\"hello\"); \\n```'</span>;\n\n<span class=hljs-comment>// Async highlighting with pygmentize-bundled</span>\nmarked.setOptions({\n  highlight: <span class=hljs-function><span class=hljs-keyword>function</span> (<span class=hljs-params>code, lang, callback</span>) </span>{\n    <span class=hljs-built_in>require</span>(<span class=hljs-string>'pygmentize-bundled'</span>)({ lang: lang, format: <span class=hljs-string>'html'</span> }, code, <span class=hljs-function><span class=hljs-keyword>function</span> (<span class=hljs-params>err, result</span>) </span>{\n      callback(err, result.toString());\n    });\n  }\n});\n\n<span class=hljs-comment>// Using async version of marked</span>\nmarked(markdownString, <span class=hljs-function><span class=hljs-keyword>function</span> (<span class=hljs-params>err, content</span>) </span>{\n  <span class=hljs-keyword>if</span> (err) <span class=hljs-keyword>throw</span> err;\n  <span class=hljs-built_in>console</span>.log(content);\n});\n\n<span class=hljs-comment>// Synchronous highlighting with highlight.js</span>\nmarked.setOptions({\n  highlight: <span class=hljs-function><span class=hljs-keyword>function</span> (<span class=hljs-params>code</span>) </span>{\n    <span class=hljs-keyword>return</span> <span class=hljs-built_in>require</span>(<span class=hljs-string>'highlight.js'</span>).highlightAuto(code).value;\n  }\n});\n\n<span class=hljs-built_in>console</span>.log(marked(markdownString));\n</code></pre> <h4 id=highlight-arguments>highlight arguments</h4> <p><code>code</code></p> <p>Type: <code>string</code></p> <p>The section of code to pass to the highlighter.</p> <p><code>lang</code></p> <p>Type: <code>string</code></p> <p>The programming language specified in the code block.</p> <p><code>callback</code></p> <p>Type: <code>function</code></p> <p>The callback function to call when using an async highlighter.</p> <h3 id=renderer>renderer</h3> <p>Type: <code>object</code> Default: <code>new Renderer()</code></p> <p>An object containing functions to render tokens to HTML.</p> <h4 id=overriding-renderer-methods>Overriding renderer methods</h4> <p>The renderer option allows you to render tokens in a custom manner. Here is an example of overriding the default heading token rendering by adding an embedded anchor tag like on GitHub:</p> <pre><code class=\"hljs javascript\"><span class=hljs-keyword>var</span> marked = <span class=hljs-built_in>require</span>(<span class=hljs-string>'marked'</span>);\n<span class=hljs-keyword>var</span> renderer = <span class=hljs-keyword>new</span> marked.Renderer();\n\nrenderer.heading = <span class=hljs-function><span class=hljs-keyword>function</span> (<span class=hljs-params>text, level</span>) </span>{\n  <span class=hljs-keyword>var</span> escapedText = text.toLowerCase().replace(<span class=hljs-regexp>/[^\\w]+/g</span>, <span class=hljs-string>'-'</span>);\n\n  <span class=hljs-keyword>return</span> <span class=hljs-string>'&lt;h'</span> + level + <span class=hljs-string>'&gt;&lt;a name=\"'</span> +\n                escapedText +\n                 <span class=hljs-string>'\" class=\"anchor\" href=\"#'</span> +\n                 escapedText +\n                 <span class=hljs-string>'\"&gt;&lt;span class=\"header-link\"&gt;&lt;/span&gt;&lt;/a&gt;'</span> +\n                  text + <span class=hljs-string>'&lt;/h'</span> + level + <span class=hljs-string>'&gt;'</span>;\n},\n\n<span class=hljs-built_in>console</span>.log(marked(<span class=hljs-string>'# heading+'</span>, { renderer: renderer }));\n</code></pre> <p>This code will output the following HTML:</p> <pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>h1</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>a</span> <span class=hljs-attr>name</span>=<span class=hljs-string>\"heading-\"</span> <span class=hljs-attr>class</span>=<span class=hljs-string>\"anchor\"</span> <span class=hljs-attr>href</span>=<span class=hljs-string>\"#heading-\"</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>span</span> <span class=hljs-attr>class</span>=<span class=hljs-string>\"header-link\"</span>&gt;</span><span class=hljs-tag>&lt;/<span class=hljs-name>span</span>&gt;</span>\n  <span class=hljs-tag>&lt;/<span class=hljs-name>a</span>&gt;</span>\n  heading+\n<span class=hljs-tag>&lt;/<span class=hljs-name>h1</span>&gt;</span>\n</code></pre> <h4 id=block-level-renderer-methods>Block level renderer methods</h4> <ul> <li>code(<em>string</em> code, <em>string</em> language)</li> <li>blockquote(<em>string</em> quote)</li> <li>html(<em>string</em> html)</li> <li>heading(<em>string</em> text, <em>number</em> level)</li> <li>hr()</li> <li>list(<em>string</em> body, <em>boolean</em> ordered)</li> <li>listitem(<em>string</em> text)</li> <li>paragraph(<em>string</em> text)</li> <li>table(<em>string</em> header, <em>string</em> body)</li> <li>tablerow(<em>string</em> content)</li> <li>tablecell(<em>string</em> content, <em>object</em> flags)</li> </ul> <p><code>flags</code> has the following properties:</p> <pre><code class=\"hljs js\">{\n    header: <span class=hljs-literal>true</span> || <span class=hljs-literal>false</span>,\n    align: <span class=hljs-string>'center'</span> || <span class=hljs-string>'left'</span> || <span class=hljs-string>'right'</span>\n}\n</code></pre> <h4 id=inline-level-renderer-methods>Inline level renderer methods</h4> <ul> <li>strong(<em>string</em> text)</li> <li>em(<em>string</em> text)</li> <li>codespan(<em>string</em> code)</li> <li>br()</li> <li>del(<em>string</em> text)</li> <li>link(<em>string</em> href, <em>string</em> title, <em>string</em> text)</li> <li>image(<em>string</em> href, <em>string</em> title, <em>string</em> text)</li> </ul> <h3 id=gfm>gfm</h3> <p>Type: <code>boolean</code> Default: <code>true</code></p> <p>Enable <a href=https://help.github.com/articles/github-flavored-markdown>GitHub flavored markdown</a>.</p> <h3 id=tables>tables</h3> <p>Type: <code>boolean</code> Default: <code>true</code></p> <p>Enable GFM <a href=https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet#wiki-tables>tables</a>. This option requires the <code>gfm</code> option to be true.</p> <h3 id=breaks>breaks</h3> <p>Type: <code>boolean</code> Default: <code>false</code></p> <p>Enable GFM <a href=https://help.github.com/articles/github-flavored-markdown#newlines>line breaks</a>. This option requires the <code>gfm</code> option to be true.</p> <h3 id=pedantic>pedantic</h3> <p>Type: <code>boolean</code> Default: <code>false</code></p> <p>Conform to obscure parts of <code>markdown.pl</code> as much as possible. Don&#39;t fix any of the original markdown bugs or poor behavior.</p> <h3 id=sanitize>sanitize</h3> <p>Type: <code>boolean</code> Default: <code>false</code></p> <p>Sanitize the output. Ignore any HTML that has been input.</p> <h3 id=smartlists>smartLists</h3> <p>Type: <code>boolean</code> Default: <code>true</code></p> <p>Use smarter list behavior than the original markdown. May eventually be default with the old behavior moved into <code>pedantic</code>.</p> <h3 id=smartypants>smartypants</h3> <p>Type: <code>boolean</code> Default: <code>false</code></p> <p>Use &quot;smart&quot; typograhic punctuation for things like quotes and dashes.</p> <h2 id=access-to-lexer-and-parser>Access to lexer and parser</h2> <p>You also have direct access to the lexer and parser if you so desire.</p> <pre><code class=\"hljs js\"><span class=hljs-keyword>var</span> tokens = marked.lexer(text, options);\n<span class=hljs-built_in>console</span>.log(marked.parser(tokens));\n</code></pre> <pre><code class=\"hljs js\"><span class=hljs-keyword>var</span> lexer = <span class=hljs-keyword>new</span> marked.Lexer(options);\n<span class=hljs-keyword>var</span> tokens = lexer.lex(text);\n<span class=hljs-built_in>console</span>.log(tokens);\n<span class=hljs-built_in>console</span>.log(lexer.rules);\n</code></pre> <h2 id=cli>CLI</h2> <pre><code class=\"hljs bash\">$ marked -o hello.html\nhello world\n^D\n$ cat hello.html\n&lt;p&gt;hello world&lt;/p&gt;\n</code></pre> <h2 id=philosophy-behind-marked>Philosophy behind marked</h2> <p>The point of marked was to create a markdown compiler where it was possible to frequently parse huge chunks of markdown without having to worry about caching the compiled output somehow...or blocking for an unnecesarily long time.</p> <p>marked is very concise and still implements all markdown features. It is also now fully compatible with the client-side.</p> <p>marked more or less passes the official markdown test suite in its entirety. This is important because a surprising number of markdown compilers cannot pass more than a few tests. It was very difficult to get marked as compliant as it is. It could have cut corners in several areas for the sake of performance, but did not in order to be exactly what you expect in terms of a markdown rendering. In fact, this is why marked could be considered at a disadvantage in the benchmarks above.</p> <p>Along with implementing every markdown feature, marked also implements <a href=http://github.github.com/github-flavored-markdown/ >GFM features</a>.</p> <h2 id=benchmarks>Benchmarks</h2> <p>node v0.8.x</p> <pre><code class=\"hljs bash\">$ node <span class=hljs-built_in>test</span> --bench\nmarked completed <span class=hljs-keyword>in</span> 3411ms.\nmarked (gfm) completed <span class=hljs-keyword>in</span> 3727ms.\nmarked (pedantic) completed <span class=hljs-keyword>in</span> 3201ms.\nrobotskirt completed <span class=hljs-keyword>in</span> 808ms.\nshowdown (reuse converter) completed <span class=hljs-keyword>in</span> 11954ms.\nshowdown (new converter) completed <span class=hljs-keyword>in</span> 17774ms.\nmarkdown-js completed <span class=hljs-keyword>in</span> 17191ms.\n</code></pre> <p><strong>Marked is now faster than Discount, which is written in C.</strong></p> <p>For those feeling skeptical: These benchmarks run the entire markdown test suite 1000 times. The test suite tests every feature. It doesn&#39;t cater to specific aspects.</p> <h3 id=pro-level>Pro level</h3> <p>You also have direct access to the lexer and parser if you so desire.</p> <pre><code class=\"hljs js\"><span class=hljs-keyword>var</span> tokens = marked.lexer(text, options);\n<span class=hljs-built_in>console</span>.log(marked.parser(tokens));\n</code></pre> <pre><code class=\"hljs js\"><span class=hljs-keyword>var</span> lexer = <span class=hljs-keyword>new</span> marked.Lexer(options);\n<span class=hljs-keyword>var</span> tokens = lexer.lex(text);\n<span class=hljs-built_in>console</span>.log(tokens);\n<span class=hljs-built_in>console</span>.log(lexer.rules);\n</code></pre> <pre><code class=\"hljs bash\">$ node\n&gt; require(<span class=hljs-string>'marked'</span>).lexer(<span class=hljs-string>'&gt; i am using marked.'</span>)\n[ { <span class=hljs-built_in>type</span>: <span class=hljs-string>'blockquote_start'</span> },\n  { <span class=hljs-built_in>type</span>: <span class=hljs-string>'paragraph'</span>,\n    text: <span class=hljs-string>'i am using marked.'</span> },\n  { <span class=hljs-built_in>type</span>: <span class=hljs-string>'blockquote_end'</span> },\n  links: {} ]\n</code></pre> <h2 id=running-tests-contributing>Running Tests &amp; Contributing</h2> <p>If you want to submit a pull request, make sure your changes pass the test suite. If you&#39;re adding a new feature, be sure to add your own test.</p> <p>The marked test suite is set up slightly strangely: <code>test/new</code> is for all tests that are not part of the original markdown.pl test suite (this is where your test should go if you make one). <code>test/original</code> is only for the original markdown.pl tests. <code>test/tests</code> houses both types of tests after they have been combined and moved/generated by running <code>node test --fix</code> or <code>marked --test --fix</code>.</p> <p>In other words, if you have a test to add, add it to <code>test/new/</code> and then regenerate the tests with <code>node test --fix</code>. Commit the result. If your test uses a certain feature, for example, maybe it assumes GFM is <em>not</em> enabled, you can add <code>.nogfm</code> to the filename. So, <code>my-test.text</code> becomes <code>my-test.nogfm.text</code>. You can do this with any marked option. Say you want line breaks and smartypants enabled, your filename should be: <code>my-test.breaks.smartypants.text</code>.</p> <p>To run the tests:</p> <pre><code class=\"hljs bash\"><span class=hljs-built_in>cd</span> marked/\nnode <span class=hljs-built_in>test</span>\n</code></pre> <h3 id=contribution-and-license-agreement>Contribution and License Agreement</h3> <p>If you contribute code to this project, you are implicitly allowing your code to be distributed under the MIT license. You are also implicitly verifying that all code is your original work. <code>&lt;/legalese&gt;</code></p> <h2 id=license>License</h2> <p>Copyright (c) 2011-2014, Christopher Jeffrey. (MIT License)</p> <p>See LICENSE for more info.</p>";

/***/ },
/* 112 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>wv-off-canvas-wrap</span> <span class=hljs-attr>ref</span>=<span class=hljs-string>\"main\"</span>&gt;</span>\n  ...\n  <span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"nav\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n  ...\n<span class=hljs-tag>&lt;/<span class=hljs-name>wv-off-canvas-wrap</span>&gt;</span>\n\n<span class=hljs-tag>&lt;<span class=hljs-name>wv-off-canvas</span>\n  <span class=hljs-attr>class</span>=<span class=hljs-string>\"nav\"</span>\n  <span class=hljs-attr>ref</span>=<span class=hljs-string>\"nav\"</span>\n  <span class=hljs-attr>wrap-ref</span>=<span class=hljs-string>\"main\"</span>\n  <span class=hljs-attr>overlay-background</span>=<span class=hljs-string>\"transparent\"</span>\n  <span class=hljs-attr>role</span>=<span class=hljs-string>\"navigation\"</span>\n  <span class=hljs-attr>aria-labelledby</span>=<span class=hljs-string>\"title\"</span>\n  @<span class=hljs-attr>opened</span>=<span class=hljs-string>\"onOpen\"</span>\n  @<span class=hljs-attr>closed</span>=<span class=hljs-string>\"onClose\"</span>\n&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"nav\"</span>&gt;</span>Close<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>h1</span> <span class=hljs-attr>id</span>=<span class=hljs-string>\"title\"</span>&gt;</span>Navigation<span class=hljs-tag>&lt;/<span class=hljs-name>h1</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>a</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"nav\"</span>&gt;</span>Link to someplace<span class=hljs-tag>&lt;/<span class=hljs-name>a</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>wv-off-canvas</span>&gt;</span>\n</code></pre> <pre><code class=\"hljs js\"><span class=hljs-keyword>export</span> <span class=hljs-keyword>default</span> {\n  <span class=hljs-comment>// ...</span>\n  methods: {\n    onOpen () {\n      <span class=hljs-built_in>console</span>.log(<span class=hljs-string>'OffCanvas opened'</span>)\n    },\n    onClose () {\n      <span class=hljs-built_in>console</span>.log(<span class=hljs-string>'OffCanvas closed'</span>)\n    }\n  }\n}\n</code></pre> <pre><code class=\"hljs scss\"><span class=hljs-selector-class>.nav</span> {\n  <span class=hljs-attribute>background-color</span>: <span class=hljs-number>#400255</span>;\n  <span class=hljs-attribute>color</span>: <span class=hljs-number>#ffffff</span>;\n  <span class=hljs-attribute>max-width</span>: <span class=hljs-number>25rem</span>;\n  <span class=hljs-attribute>padding</span>: <span class=hljs-number>2rem</span> <span class=hljs-number>0</span>;\n  <span class=hljs-attribute>text-align</span>: center;\n}\n</code></pre>";

/***/ },
/* 113 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"sidebar2\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n\n<span class=hljs-tag>&lt;<span class=hljs-name>wv-off-canvas</span> <span class=hljs-attr>ref</span>=<span class=hljs-string>\"sidebar2\"</span> <span class=hljs-attr>:close-on-esc</span>=<span class=hljs-string>\"false\"</span> <span class=hljs-attr>:close-on-outside-click</span>=<span class=hljs-string>\"false\"</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>h1</span>&gt;</span>Sidebar<span class=hljs-tag>&lt;/<span class=hljs-name>h1</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"sidebar2\"</span>&gt;</span>Close<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>wv-off-canvas</span>&gt;</span>\n</code></pre>";

/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs js\"><span class=hljs-keyword>import</span> * <span class=hljs-keyword>as</span> OffCanvas <span class=hljs-keyword>from</span> <span class=hljs-string>'wovue-off-canvas'</span>\n\n<span class=hljs-keyword>export</span> <span class=hljs-keyword>default</span> {\n  <span class=hljs-comment>// ...</span>\n  directives: {\n    <span class=hljs-string>'off-canvas'</span>: OffCanvas.directive\n  },\n  components: {\n    <span class=hljs-string>'wv-off-canvas'</span>: OffCanvas.components.OffCanvas,\n    <span class=hljs-string>'wv-off-canvas-wrap'</span>: OffCanvas.components.OffCanvasWrap\n  },\n  <span class=hljs-comment>// ...</span>\n}\n</code></pre>";

/***/ },
/* 115 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs js\"><span class=hljs-keyword>import</span> Vue <span class=hljs-keyword>from</span> <span class=hljs-string>'vue'</span>\n<span class=hljs-keyword>import</span> * <span class=hljs-keyword>as</span> OffCanvas <span class=hljs-keyword>from</span> <span class=hljs-string>'wovue-off-canvas'</span>\n\nVue.component(<span class=hljs-string>'sidebar'</span>, OffCanvas.components.OffCanvas)\nVue.component(<span class=hljs-string>'sidebar-pusher'</span>, OffCanvas.components.OffCanvasWrap)\n\nVue.directive(<span class=hljs-string>'sidebar'</span>, OffCanvas.directive)\n</code></pre>";

/***/ },
/* 116 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs js\"><span class=hljs-comment>// with webpack you can import css</span>\n<span class=hljs-built_in>require</span>(<span class=hljs-string>'wovue-off-canvas/dist/off-canvas.css'</span>)\n\n<span class=hljs-keyword>import</span> Vue <span class=hljs-keyword>from</span> <span class=hljs-string>'vue'</span>\n<span class=hljs-keyword>import</span> OffCanvas <span class=hljs-keyword>from</span> <span class=hljs-string>'wovue-off-canvas'</span>\n\nVue.use(OffCanvas)\n</code></pre>";

/***/ },
/* 117 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-meta>&lt;!DOCTYPE html&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>html</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>head</span>&gt;</span>\n    ...\n    <span class=hljs-tag>&lt;<span class=hljs-name>link</span> <span class=hljs-attr>rel</span>=<span class=hljs-string>\"stylesheet\"</span> <span class=hljs-attr>href</span>=<span class=hljs-string>\"https://unpkg.com/wovue-off-canvas/dist/off-canvas.css\"</span>/&gt;</span>\n    ...\n  <span class=hljs-tag>&lt;/<span class=hljs-name>head</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>body</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>script</span> <span class=hljs-attr>src</span>=<span class=hljs-string>\"path/to/vue.js\"</span>&gt;</span><span class=undefined></span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>script</span> <span class=hljs-attr>src</span>=<span class=hljs-string>\"https://unpkg.com/wovue-off-canvas/dist/off-canvas.js\"</span>&gt;</span><span class=undefined></span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>script</span> <span class=hljs-attr>src</span>=<span class=hljs-string>\"path/to/app.js\"</span>&gt;</span><span class=undefined></span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n  <span class=hljs-tag>&lt;/<span class=hljs-name>body</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>html</span>&gt;</span>\n</code></pre>";

/***/ },
/* 118 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"menu\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>wv-off-canvas</span> <span class=hljs-attr>ref</span>=<span class=hljs-string>\"menu\"</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>h1</span>&gt;</span>Menu<span class=hljs-tag>&lt;/<span class=hljs-name>h1</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"menu\"</span>&gt;</span>Close<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>wv-off-canvas</span>&gt;</span>\n</code></pre>";

/***/ },
/* 119 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>wv-off-canvas-wrap</span> <span class=hljs-attr>ref</span>=<span class=hljs-string>\"main\"</span>&gt;</span>\n  <span class=hljs-comment>&lt;!-- content to push --&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"otherMenu\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n\n  <span class=hljs-tag>&lt;<span class=hljs-name>wv-off-canvas</span> <span class=hljs-attr>class</span>=<span class=hljs-string>\"my-offcanvas\"</span> <span class=hljs-attr>wrap-ref</span>=<span class=hljs-string>\"main\"</span> <span class=hljs-attr>ref</span>=<span class=hljs-string>\"otherMenu\"</span> <span class=hljs-attr>align</span>=<span class=hljs-string>\"right\"</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>h1</span>&gt;</span>Other menu<span class=hljs-tag>&lt;/<span class=hljs-name>h1</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"otherMenu\"</span> <span class=hljs-attr>style</span>=<span class=hljs-string>\"...\"</span>&gt;</span>Close<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n  <span class=hljs-tag>&lt;/<span class=hljs-name>wv-off-canvas</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>wv-off-canvas-wrap</span>&gt;</span>\n</code></pre> <pre><code class=\"hljs scss\"><span class=hljs-selector-class>.my-off-canvas</span> {\n  <span class=hljs-attribute>background-color</span>: <span class=hljs-number>#2ecc40</span>;\n  <span class=hljs-attribute>padding</span>: <span class=hljs-number>2rem</span>;\n}\n</code></pre>";

/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\">...\n<span class=hljs-tag>&lt;<span class=hljs-name>wv-off-canvas</span> <span class=hljs-attr>v-transfer-dom</span> &gt;</span>\n  ...\n<span class=hljs-tag>&lt;/<span class=hljs-name>wv-off-canvas</span>&gt;</span>\n</code></pre>";

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>wv-off-canvas</span> <span class=hljs-attr>ref</span>=<span class=hljs-string>\"my-off-canvas\"</span>&gt;</span>\n  <span class=hljs-comment>&lt;!-- off canvas content --&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>wv-off-canvas</span>&gt;</span>\n</code></pre>";

/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:open</span>=<span class=hljs-string>\"my-off-canvas\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:close</span>=<span class=hljs-string>\"my-off-canvas\"</span>&gt;</span>Close<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>button</span> <span class=hljs-attr>v-off-canvas:toggle</span>=<span class=hljs-string>\"my-off-canvas\"</span>&gt;</span>Toggle<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n</code></pre>";

/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>button</span> @<span class=hljs-attr>click</span>=<span class=hljs-string>\"openOffCanvas\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>button</span> @<span class=hljs-attr>click</span>=<span class=hljs-string>\"closeOffCanvas\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>button</span> @<span class=hljs-attr>click</span>=<span class=hljs-string>\"toggleOffCanvas\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n</code></pre> <pre><code class=\"hljs js\"><span class=hljs-keyword>export</span> <span class=hljs-keyword>default</span> {\n  <span class=hljs-comment>// ...</span>\n  methods: {\n    openOffCanvas () {\n      <span class=hljs-keyword>this</span>.$wv.offCanvas.open(<span class=hljs-string>'my-off-canvas'</span>)\n    },\n    closeOffCanvas () {\n      <span class=hljs-keyword>this</span>.$wv.offCanvas.close(<span class=hljs-string>'my-off-canvas'</span>)\n    },\n    toggleOffCanvas () {\n      <span class=hljs-keyword>this</span>.$wv.offCanvas.toggle(<span class=hljs-string>'my-off-canvas'</span>)\n    }\n  }\n}\n</code></pre>";

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>button</span> @<span class=hljs-attr>click</span>=<span class=hljs-string>\"openOffCanvas\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>button</span> @<span class=hljs-attr>click</span>=<span class=hljs-string>\"closeOffCanvas\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>button</span> @<span class=hljs-attr>click</span>=<span class=hljs-string>\"toggleOffCanvas\"</span>&gt;</span>Open<span class=hljs-tag>&lt;/<span class=hljs-name>button</span>&gt;</span>\n</code></pre> <pre><code class=\"hljs js\"><span class=hljs-keyword>import</span> {toggleOffCanvas, closeOffCanvas, openOffCanvas} <span class=hljs-keyword>from</span> <span class=hljs-string>'wovue-off-canvas'</span>\n\n<span class=hljs-keyword>export</span> <span class=hljs-keyword>default</span> {\n  <span class=hljs-comment>// ...</span>\n  methods: {\n    openOffCanvas () {\n      openOffCanvas(<span class=hljs-string>'my-off-canvas'</span>)\n    },\n    closeOffCanvas () {\n      closeOffCanvas(<span class=hljs-string>'my-off-canvas'</span>)\n    },\n    toggleOffCanvas () {\n      toggleOffCanvas(<span class=hljs-string>'my-off-canvas'</span>)\n    }\n  }\n}\n</code></pre>";

/***/ },
/* 125 */,
/* 126 */,
/* 127 */
/***/ function(module, exports) {

	module.exports = " <a class=github-corner :href=ghLink target=_blank rel=\"noopener noreferrer\" aria-label=\"View source on Github\" title=\"View source on Github\"> <svg width=80 height=80 viewBox=\"0 0 250 250\" :style=\"{fill: background, color: color, position: 'absolute', top: 0, border: 0, right: 0}\" aria-hidden=true> <path d=\"M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z\"></path> <path class=octo-arm d=\"M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2\" fill=currentColor style=\"transform-origin: 130px 106px\"></path> <path class=octo-body d=\"M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z\" fill=currentColor></path> </svg> </a> ";

/***/ },
/* 128 */
/***/ function(module, exports) {

	module.exports = " <div> <wv-off-canvas-wrap ref=main> <sidebar></sidebar> <router-view></router-view> <gh-corner v-transfer-dom repo-user=wovue repo-name=off-canvas color=#E6E8EA background=#35495E></gh-corner> </wv-off-canvas-wrap> </div> ";

/***/ },
/* 129 */
/***/ function(module, exports) {

	module.exports = " <header class=c-sidebar> <h1 class=c-sidebar__header> <a href=#!>off-canvas</a> </h1> <nav class=c-sidebar__body role=navigation> <ul class=o-reset-list> <li class=\"c-sidebar__item c-sidebar__item--heading\"> <a v-link=\"{name: 'Home', exact: true}\">Getting started</a> </li> <li> <ul class=o-reset-list> <li class=\"c-sidebar__item c-sidebar__item--sub-heading\"> <a v-link=\"{name: 'HomeDefaultPage', exact: true}\">Installation</a> </li> <li class=\"c-sidebar__item c-sidebar__item--sub-heading\"> <a v-link=\"{name: 'HomeUsagePage'}\">Usage</a> </li> <li class=\"c-sidebar__item c-sidebar__item--sub-heading\"> <a v-link=\"{name: 'HomeApiPage'}\">Api</a> </li> </ul> </li> <li class=\"c-sidebar__item c-sidebar__item--heading\"> <a v-link=\"{name: 'Examples'}\">Examples</a> </li> <li> <ul class=o-reset-list> <li class=\"c-sidebar__item c-sidebar__item--sub-heading\"> <a v-link=\"{name: 'ExamplesDefaultPage', exact: true}\">Various</a> </li> <li class=\"c-sidebar__item c-sidebar__item--sub-heading\"> <a v-link=\"{name: 'ExamplesRealWorldPage'}\">Real world</a> </li> </ul> </li> </ul> </nav> </header> ";

/***/ },
/* 130 */
/***/ function(module, exports) {

	module.exports = " <main class=c-main role=main> <section class=c-main__section> <h2 class=\"c-main__heading u-gutter\">Main title</h2> <section class=c-main__sub-section> <h3 class=\"c-main__sub-heading u-gutter\">Main sub title</h3> <div class=\"c-item u-gutter\"> <h4 class=c-item__heading>Item title</h4> <div class=c-item__description> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation</p> <p>Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p> </div> <h5 class=c-item__sub-heading>Item sub title (code)</h5> <div class=c-item__code-wrapper v-html=snippet></div> <h5 class=c-item__sub-heading>Item sub title (table)</h5> <app-table class=c-item__table :data=table></app-table> </div> </section> </section> <app-footer></app-footer> </main> ";

/***/ },
/* 131 */
/***/ function(module, exports) {

	module.exports = " <main class=c-main> <article class=\"markdown-body c-markdown-body u-gutter\" v-html=docsMarkdownExample></article> <app-footer></app-footer> </main> ";

/***/ },
/* 132 */
/***/ function(module, exports) {

	module.exports = " <section class=c-main__sub-section> <h3 class=\"c-main__sub-heading u-gutter\">Various</h3> <div class=\"c-item u-gutter\"> <h4 class=c-item__heading>Example 1</h4> <div class=c-item__description> <ul> <li>Custom styles</li> <li>Scrollable</li> </ul> </div> <h5 class=c-item__sub-heading>Code:</h5> <div class=c-item__code-wrapper v-html=snippets.defaultExample></div> <h5 class=c-item__sub-heading>Result:</h5> <div class=c-play-around> <wv-off-canvas ref=sidebar class=my-sidebar> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> <button v-off-canvas:close=sidebar type=button>Close</button> </wv-off-canvas> <button v-off-canvas:open=sidebar type=button>Open</button> </div> <h4 class=c-item__heading>Example 2</h4> <div class=c-item__description> <ul> <li>Close on <code>esc</code> disabled</li> <li>Close on outside <code>click</code> disabled</li> </ul> </div> <h5 class=c-item__sub-heading>Code:</h5> <div class=c-item__code-wrapper v-html=snippets.v01></div> <h5 class=c-item__sub-heading>Result:</h5> <div class=c-play-around> <button v-off-canvas:toggle=sidebar2>Open</button> <wv-off-canvas ref=sidebar2 :close-on-esc=false :close-on-outside-click=false> <h1>Sidebar</h1> <button v-off-canvas:toggle=sidebar2>Close</button> </wv-off-canvas> </div> </div> </section> ";

/***/ },
/* 133 */
/***/ function(module, exports) {

	module.exports = " <main class=c-main role=main> <section class=c-main__section> <h2 class=\"c-main__heading u-gutter\">Examples</h2> <router-view></router-view> </section> <app-footer></app-footer> </main> ";

/***/ },
/* 134 */
/***/ function(module, exports) {

	module.exports = " <section class=c-main__sub-section> <h3 class=\"c-main__sub-heading u-gutter\">Real world example</h3> <div class=\"c-item u-gutter\"> <div class=c-item__description> <ul> <li>Custom width</li> <li>Custom styles</li> <li>a11y attributes</li> <li>Listening to <code>closed</code> event</li> <li>Listening to <code>opened</code> event</li> </ul> </div> <h5 class=c-item__sub-heading>Code:</h5> <div class=c-item__code-wrapper v-html=snippets.rw01></div> <h5 class=c-item__sub-heading>Result:</h5> <div class=c-play-around> <wv-off-canvas class=nav v-transfer-dom wrap-ref=main ref=nav overlay-background=transparent role=navigation aria-labelledby=title @closed=onClose @opened=onOpen> <button v-off-canvas:toggle=nav>Close</button> <h1 id=title>Navigation</h1> <a v-off-canvas:toggle=nav href=https://wovue.github.io/off-canvas/#!/examples/real-world>Link to someplace</a> </wv-off-canvas> <button v-off-canvas:toggle=nav type=button>Open</button> </div> </div> </section> ";

/***/ },
/* 135 */
/***/ function(module, exports) {

	module.exports = " <section class=c-main__sub-section> <h3 class=\"c-main__sub-heading u-gutter\">API</h3> <div class=\"c-item u-gutter\"> <h4 class=c-item__heading>OffCanvas</h4> <h5 class=c-item__sub-heading>Props</h5> <app-table class=c-item__table :data=tables.offCanvas.props></app-table> <h5 class=c-item__sub-heading>Events</h5> <app-table class=c-item__table :data=tables.offCanvas.events></app-table> <h4 class=c-item__heading>OffCanvasWrap</h4> <div class=c-item__description> <p>OffCanvasWrap will push its content, when an OffCanvas references it and it is open.</p> </div> <h5 class=c-item__sub-heading>Props</h5> <app-table class=c-item__table :data=tables.offCanvasWrap.props></app-table> <h4 class=c-item__heading>Directives</h4> <h5 class=c-item__sub-heading>v-off-canvas</h5> <app-table class=c-item__table :data=tables.offCanvas.directive></app-table> </div> </section> ";

/***/ },
/* 136 */
/***/ function(module, exports) {

	module.exports = " <section class=c-main__sub-section> <h3 class=\"c-main__sub-heading u-gutter\">Installation</h3> <div class=\"c-item u-gutter\"> <div class=c-item__description> <p>You have two ways to setup <code>wovue-off-canvas</code>:</p> </div> <h4 class=c-item__heading>NPM</h4> <div class=c-item__code-wrapper v-html=snippets.installation></div> <h5 class=c-item__sub-heading>CommonJS (Webpack/Browserify)</h5> <div class=c-item__description> <p>If you are working with <code>Browserify</code>, you will have to add the <code>css</code> separately.</p> </div> <div class=c-item__code-wrapper v-html=snippets.installationCommonjs></div> <div class=c-item__description> <p>Alternatively you can add it to your components options.</p> </div> <div class=c-item__code-wrapper v-html=snippets.installationCommonjsAlternative></div> <div class=c-item__description> <p>or register the components and the directive with other names.</p> </div> <div class=c-item__code-wrapper v-html=snippets.installationCommonjsAlternative2></div> <h4 class=c-item__heading>Direct include (Browser)</h4> <div class=c-item__description> <p>Include it directly with a <code>&lt;script&gt;</code> tag. In this case, you don't need to write <code>Vue.use(OffCanvas)</code>, this will be done automatically for you.</p> </div> <div class=c-item__code-wrapper v-html=snippets.installationInclude></div> </div> </section> ";

/***/ },
/* 137 */
/***/ function(module, exports) {

	module.exports = " <main class=c-main role=main> <section class=c-main__section> <h2 class=\"c-main__heading u-gutter\">Getting started</h2> <router-view></router-view> </section> <app-footer></app-footer> </main> ";

/***/ },
/* 138 */
/***/ function(module, exports) {

	module.exports = " <section class=c-main__sub-section> <h3 class=\"c-main__sub-heading u-gutter\">Usage</h3> <div class=\"c-item u-gutter\"> <h4 class=c-item__heading>OffCanvas</h4> <div class=c-item__description> <p>First you have to create the <code>OffCanvas</code>, here's an example:</p> </div> <div class=c-item__code-wrapper v-html=snippets.usageGuide01></div> <div class=c-item__description> <p>So, now you can call the <code>OffCanvas</code>, there are three ways to handle it:</p> </div> <h5 class=c-item__sub-heading>Using the directive</h5> <div class=c-item__description> <p>The directive will add <code>'aria-expanded'</code> and <code>'aria-controls'</code> A11Y attributes.</p> </div> <div class=c-item__code-wrapper v-html=snippets.usageGuide02></div> <h5 class=c-item__sub-heading>Using the <code>$wv</code> instance</h5> <div class=c-item__description> <p>Only available if you installed it as a Plugin.</p> </div> <div class=c-item__code-wrapper v-html=snippets.usageGuide03></div> <h5 class=c-item__sub-heading>Importing the functions from src</h5> <div class=c-item__code-wrapper v-html=snippets.usageGuide04></div> <div class=c-item__description> <p>Here an examples:</p> </div> <h5 class=c-item__sub-heading>Code:</h5> <div class=c-item__code-wrapper v-html=snippets.usage01></div> <div class=c-item__description> <p>That's it!</p> </div> <h5 class=c-item__sub-heading>Result:</h5> <div class=c-play-around> <button v-off-canvas:toggle=menu>Open</button> <wv-off-canvas ref=menu> <h1>Menu</h1> <button v-off-canvas:toggle=menu>Close</button> </wv-off-canvas> </div> <h4 class=c-item__heading>OffCanvasWrap</h4> <div class=c-item__description> <p>You can optionally push your content when the <code>OffCanvas</code> is open, wrapping your content with the <code>OffCanvasWrap</code> component</p> </div> <div class=c-item__code-wrapper v-html=snippets.usage02></div> <div class=c-play-around> <button v-off-canvas:toggle=otherMenu>Open</button> <wv-off-canvas class=my-offcanvas wrap-ref=main ref=otherMenu align=right> <h1>Other menu</h1> <button v-off-canvas:toggle=otherMenu>Close</button> </wv-off-canvas> </div> <div class=c-item__description> <p>and that's it!...... oohhh wait</p> <p>This is a <code>'transform'</code> + <code>'position: fixed'</code> <a href=http://stackoverflow.com/questions/15194313/webkit-css-transform3d-position-fixed-issue>issue</a></p> <p>We can fix it moving the <code>OffCanvas</code> outside the <code>OffCanvasWrap</code>, i will use the <a href=https://github.com/rhyzx/vue-transfer-dom target=_blank rel=\"noreferrer nofollow\">v-transfer-dom</a> directive</p> </div> <div class=c-item__code-wrapper v-html=snippets.usage021></div> <div class=c-play-around> <button v-off-canvas:toggle=fixedMenu>Open</button> <wv-off-canvas v-transfer-dom class=my-offcanvas wrap-ref=main ref=fixedMenu align=right> <h1>Other menu</h1> <button v-off-canvas:toggle=fixedMenu>Close</button> </wv-off-canvas> </div> <div class=c-item__description> <p><strong>Note:</strong> Applying <code>transform</code> rule to an element will create a new stacking context, it affect the rendering of elements with position <code>fixed</code>. So we need to move the OffCanvas to the <code>body</code>, and that's it.</p> </div> </div> </section> ";

/***/ },
/* 139 */
/***/ function(module, exports) {

	module.exports = " <footer class=\"c-footer u-gutter\" role=contentinfo> <a href=https://github.com/wovue/component-template/tree/master target=_blank rel=\"noopener noreferrer\">Wovue component template</a> <a href=https://github.com/SassDoc/sassdoc-theme-default target=_blank rel=\"noopener noreferrer\">SassDoc Default Theme</a> </footer> ";

/***/ },
/* 140 */
/***/ function(module, exports) {

	module.exports = " <table> <thead> <tr> <th v-for=\"column in columns\" scope=col><span class=o-screen-reader>{{ heading }} </span>{{ column }}</th> </tr> </thead> <tbody> <tr v-for=\"row in data\"> <td v-for=\"column in columns\" scope=row :data-label=column>{{{ row[column] ? marked(row[column]) : empty }}}</td> </tr> </tbody> </table> ";

/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = " <div :aria-hidden=\"`${ariaHidden}`\"> <div class=c-off-canvas-overlay :style=\"{backgroundColor: overlayBackground}\" @click.stop=close v-if=isOpen transition=wv-off-canvas-overlay tabindex=-1></div> <div class=c-off-canvas :class=[class] :style=\"{maxWidth: offCanvasMaxWidth}\" v-show=isOpen v-el:off-canvas @animationend=onAnimationEnd :transition=transitionClass :aria-labelledby=ariaLabelledby :role=role :id=ref> <slot></slot> </div> </div> ";

/***/ },
/* 142 */
/***/ function(module, exports) {

	module.exports = " <div class=c-off-canvas-wrap :style=\"{overflow: isOpen ? 'hidden' : false}\"> <div class=c-off-canvas-wrap__content :style=\"{transform: contentTransform}\"> <slot></slot> </div> </div> ";

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(101)
	__vue_script__ = __webpack_require__(47)
	__vue_template__ = __webpack_require__(127)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(48)
	__vue_template__ = __webpack_require__(128)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(102)
	__vue_script__ = __webpack_require__(49)
	__vue_template__ = __webpack_require__(129)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(103)
	__vue_script__ = __webpack_require__(50)
	__vue_template__ = __webpack_require__(130)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(104)
	__vue_script__ = __webpack_require__(51)
	__vue_template__ = __webpack_require__(131)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(105)
	__vue_script__ = __webpack_require__(52)
	__vue_template__ = __webpack_require__(132)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(53)
	__vue_template__ = __webpack_require__(133)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(106)
	__vue_script__ = __webpack_require__(54)
	__vue_template__ = __webpack_require__(134)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(55)
	__vue_template__ = __webpack_require__(135)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(56)
	__vue_template__ = __webpack_require__(136)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(57)
	__vue_template__ = __webpack_require__(137)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(107)
	__vue_script__ = __webpack_require__(58)
	__vue_template__ = __webpack_require__(138)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(108)
	__vue_script__ = __webpack_require__(59)
	__vue_template__ = __webpack_require__(139)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(109)
	__vue_script__ = __webpack_require__(60)
	__vue_template__ = __webpack_require__(140)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(61)
	__vue_template__ = __webpack_require__(141)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(62)
	__vue_template__ = __webpack_require__(142)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.js
 **/